export { default } from './BadgeList';



// WEBPACK FOOTER //
// ./src/components/trending/BadgeList/index.js